<div class="checkout-result-page page-section">
  <ng-template #activateEsimPart>
    <div class="activate-esim-part">
      <h4 class="head">How to activate your eSIM?</h4>
      <div class="activate-steps">
        <div class="step-flex">
          <p><b>1-</b></p>
          <p>
            You must have the phone you will use with the eSIM in hand, to <b>scan the QR code</b> presented on the screen during activation.
          </p>
        </div>
        <div class="step-flex">
          <p><b>2-</b></p>
          <p>To proceed to activate your new eSIM, click '<b>Start eSIM activation</b>' button.</p>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="result-container">
    <h3 class="header">Purchase Successful!</h3>
    <ng-container *ngIf="!isChangePlanSummary">
      <p class="subheader">{{subHeaderTitle}}</p>
      <div class="info-banner success-background">
        <div class="flex">
          <img src="assets/icon/banner-success-icon.svg" width="32" height="32" alt="Success Icon">
          <div class="banner-content">
            <h5 class="title">Your Order ID is:</h5>
            <div class="actions">
              <button class="button tertiary" (click)="goToOrderDetail(orderId)">{{orderId}}</button>
            </div>
          </div>
        </div>
      </div>
      <hr class="border">
    </ng-container>
    <ng-container *ngIf="!!isChangePlanSummary">
      <p><b>Your order has been placed:</b></p>
      <div class="order-id-part">
        <p class="smaller">Your Order ID is:</p>
        <button class="button tertiary" (click)="goToOrderDetail(orderId)">{{orderId}}</button>
      </div>
      <div class="info-banner default-background">
        <div class="flex">
          <img src="assets/icon/timer-icon.svg" width="54" height="54" alt="Timer Icon">
          <div class="banner-content">
            <p class="desc-a last smaller">Note that it may take several minutes for the new plan services to fully set
              on the network.</p>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!isChangePlanSummary && !isPlanAddon && !isOrderSim && !isSuccessfulMultiplePurchases">
      <ng-container *ngIf="!userPlanId && !purchasedPlan?.eSIM">
        <div class="content-part">
          <p class="desc first">Look out for your <b>new SIM Card</b> in the mail!</p>
          <p class="desc">Once your SIM card <b>arrives</b> in a couple of days, we will help you get your SIM card
            <b>activated</b> with a brand new phone number, or <b>transfer</b> your active number (port in) from another
            provider.
          </p>
          <div class="register-phone-section"
            *ngIf="!!purchasedPlan && !purchasedPlan?.planExpectedDevice && purchasedPlan?.planDevice?.id">
            <h4 class="section-title">Your selected Phone:</h4>
            <p class="desc first">The following device will be connected to your plan:</p>

            <div class="phone-details">
              <p class="desc bottom"><b>{{purchasedPlan?.planDevice?.model}}</b></p>
              <p class="desc last">IMEI: <b>{{purchasedPlan?.planDevice?.id}}</b></p>
            </div>
          </div>
          <p class="desc last">You can check your device’s compatibility, view your plan details and activate your SIM
            through your <a (click)="goToPendingActivation()">Purchased Plans</a> page.</p>
          <div class="content-actions long">
            <button class="button primary" (click)="goToHome()">Done</button>
            <button class="button secondary" (click)="goToOrderDetail(orderId)">View my Order</button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!!userPlanId">
        <div class="content-part" *ngIf="!purchasedPlan?.eSIM || (!!purchasedPlan?.eSIM && !!isActivationFlow)">
          <p class="desc last">You may now proceed to <b>activate your plan</b> & {{!!purchasedPlan?.eSIM ? 'e' :
            ''}}SIM in the next step, or at your convenience from your <a (click)="goToPendingActivation()">Purchased
              Plans</a> page!</p>
          <div class="content-actions">
            <button class="button primary" (click)="goToActivation()" id="continue-to-activation-button">Activate
              Now</button>
            <button class="button secondary" (click)="goToHome()">Activate Later</button>
          </div>
        </div>
        <div class="content-part" *ngIf="!!purchasedPlan && !!purchasedPlan?.eSIM && !isActivationFlow">
          <p class="desc bottom">Your <b>Plan & eSIM</b> can be found in your <a
              (click)="goToPendingActivation()">Purchased Plans</a> section in your Account.</p>
          <p class="desc last">Both are ready for activation, anytime, anywhere at your convenience!</p>
          <ng-container *ngTemplateOutlet="activateEsimPart"></ng-container>
          <div class="content-actions long">
            <button class="button primary" (click)="goToHome()">Done</button>
            <button class="button secondary" (click)="goToOrderDetail(orderId)">View my Order</button>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="isOrderSim && !isPlanAddon && !isChangePlanSummary">
      <div class="content-part">
        <ng-container *ngIf="!purchasedPlan?.eSimDetails">
          <p class="desc first">Look out for your <b>Replacement SIM Card</b> in the mail!</p>
          <p class="desc last">You can view your plan details and activate it through your <a
              (click)="goToAccountSummary()">Account Summary</a> page.
          </p>
        </ng-container>
        <ng-container *ngIf="!!purchasedPlan?.eSimDetails">
          <p class="desc last">Your <b>Replacement eSIM</b> is ready for activation from your <a
              (click)="goToAccountSummary()">Account Summary</a> page.
          </p>
          <ng-container *ngTemplateOutlet="activateEsimPart"></ng-container>
        </ng-container>
        <div class="content-actions long">
          <button class="button primary" (click)="goToHome()">Done</button>
          <button class="button secondary" (click)="goToOrderDetail(orderId)">View my Order</button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isChangePlanSummary && !isOrderSim && !isPlanAddon">
      <div class="content-part">
        <p class="desc last">Please refresh your <a (click)="goToAccountSummary()">Account Summary</a> page in a few
          minutes to see the new data balances.</p>
        <div class="content-actions">
          <button class="button primary" (click)="goToHome()">Done</button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isPlanAddon && !isChangePlanSummary && !isOrderSim">
      <div class="content-part">
        <p class="desc last">You can view your plan and <b>add-ons</b> through your <a
            (click)="goToAccountSummary()">Account Summary</a> page.</p>
        <div class="content-actions">
          <button class="button primary" (click)="goToHome()">Done</button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!!isSuccessfulMultiplePurchases">
      <div class="content-part">
        <ng-container *ngIf="isSuccessfulMultiplePurchases === 'both'">
          <ng-container *ngIf="!purchasedPlan?.eSimDetails">
            <p class="desc first">Look out for your <b>Replacement SIM Card</b> in the mail!</p>
            <p class="desc last">You can view your plan <b>add-ons</b> and details, and activate your plan through your
              <a (click)="goToAccountSummary()">Account Summary</a> page.
            </p>
          </ng-container>
          <ng-container *ngIf="!!purchasedPlan?.eSimDetails">
            <p class="desc last">
              Your eSIM is ready for activation! 
            </p>
            <p class="desc last">
              You can view your purchase details on your <a (click)="goToAccountSummary()">Account Summary</a> page.
            </p>
            <ng-container *ngTemplateOutlet="activateEsimPart"></ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isSuccessfulMultiplePurchases === 'addon'">
          <p class="desc last">Your SIM has <b>NOT</b> been successfully ordered.</p>
        </ng-container>
        <div class="content-actions column" *ngIf="isSuccessfulMultiplePurchases === 'both' && purchasedPlan?.eSimDetails; else defaultActions">
          <button class="button primary" (click)="goToActivation()">Start eSIM Activation</button>
          <button class="button tertiary" (click)="goToHome()">Done</button>
        </div>
        <ng-template #defaultActions>
          <div class="content-actions long">
            <button class="button primary" (click)="goToHome()">Done</button>
            <button class="button secondary" (click)="goToOrderDetail(orderId)">View my Order</button>
          </div>  
        </ng-template>
      </div>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="!!isMoneySavingReferral">
  <iframe [src]="trustedUrl | safe" frameborder="0" scrolling="no" width="1" height="1"
    style="visibility:hidden;"></iframe>
</ng-container>